import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from '../core/api.service';
import { passwordStrength } from '../core/app-date.pipe';
import { ToastService } from '../core/toast.service';

@Component({
  selector: 'app-forgot-password',
  styles: ['.auth-banner { display: block; width: 100%; max-width: 100%; height: auto; margin: 0 0 6px; }'],
  template: `
  <div class="auth-wrap">
    <div class="auth-card wide">
      <img class="auth-banner" src="assets/header-banner.png" alt="AAA Academy · College Campus Online">
      <div class="auth-narrow">
      <h2>Forgot Password</h2>
      <p class="muted small">Enter your username or the email address on your account, and we'll send a password reset link to that email.</p>
      <form (ngSubmit)="submit()" #f="ngForm">
        <label>Username or Email</label>
        <input name="v" [(ngModel)]="value" required placeholder="e.g. jdoe@company.com">
        <div class="alert ok" *ngIf="sent">{{ sent }}</div>
        <div class="alert err" *ngIf="error">{{ error }}</div>
        <button class="btn primary block" [disabled]="busy || !f.valid">{{ busy ? 'Sending…' : 'Send Reset Link' }}</button>
      </form>
      <p class="center"><a routerLink="/signin">Back to sign in</a></p>
      </div>
    </div>
  </div>`
})
export class ForgotPasswordComponent {
  value = '';
  busy = false;
  sent = '';
  error = '';
  constructor(private api: ApiService) {}
  submit() {
    this.busy = true; this.error = ''; this.sent = '';
    this.api.post('/auth/forgot-password', { usernameOrEmail: this.value.trim() }).subscribe(
      r => { this.busy = false; this.sent = r.message; },
      e => { this.busy = false; this.error = ApiService.message(e); }
    );
  }
}

@Component({
  selector: 'app-reset-password',
  styles: ['.auth-banner { display: block; width: 100%; max-width: 100%; height: auto; margin: 0 0 6px; }'],
  template: `
  <div class="auth-wrap">
    <div class="auth-card wide">
      <img class="auth-banner" src="assets/header-banner.png" alt="AAA Academy · College Campus Online">
      <div class="auth-narrow">
      <h2>Set a New Password</h2>
      <form (ngSubmit)="submit()" #f="ngForm">
        <label>New Password</label>
        <input name="p1" type="password" [(ngModel)]="p1" required autocomplete="new-password">
        <div class="meter" *ngIf="p1"><span [ngClass]="strength().toLowerCase()">{{ strength() }}</span></div>
        <label>Confirm Password</label>
        <input name="p2" type="password" [(ngModel)]="p2" required autocomplete="new-password">
        <div class="alert err" *ngIf="error">{{ error }}</div>
        <button class="btn primary block" [disabled]="busy || !f.valid || p1 !== p2 || strength() === 'Poor'">Update Password</button>
      </form>
      <p class="center"><a routerLink="/signin">Back to sign in</a></p>
      </div>
    </div>
  </div>`
})
export class ResetPasswordComponent implements OnInit {
  token = '';
  p1 = '';
  p2 = '';
  busy = false;
  error = '';
  constructor(private api: ApiService, private route: ActivatedRoute, private router: Router, private toast: ToastService) {}
  ngOnInit() {
    this.token = this.route.snapshot.queryParamMap.get('token') || '';
    if (!this.token) { this.error = 'This reset link is incomplete.'; }
  }
  strength() { return passwordStrength(this.p1); }
  submit() {
    this.busy = true; this.error = '';
    this.api.post('/auth/reset-password', { token: this.token, newPassword: this.p1, confirmPassword: this.p2 }).subscribe(
      r => { this.toast.ok(r.message); this.router.navigate(['/signin']); },
      e => { this.busy = false; this.error = ApiService.message(e); }
    );
  }
}
